import { render, staticRenderFns } from "./SectionResources.vue?vue&type=template&id=1640306e&"
import script from "./SectionResources.vue?vue&type=script&lang=js&"
export * from "./SectionResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports